export default __webpack_public_path__ + "media/onboarding/receiving-acf1fb4c.gif";